import React from 'react'

interface Category {
  slug: string
  name_default: string
}

interface VendorsSearchCategoryProps {
  categories: Category[]
  location_slug: string
}

const VendorsSearchCategory: React.FC<VendorsSearchCategoryProps> = ({ categories, location_slug }) => {
  return (
    <div>
      <div className="header">
        <h2>Categories</h2>
      </div>

      <div className="articles__list d-flex justify-content-start gap-4">
        {categories.map((category) => (
          <div className="article__block d-flex d-sm-block" key={category.slug}>
            <div className="article__data">
                <h5>
                  <a href={`${location_slug}/${category.slug}`}>
                    {category.name_default}
                  </a>
                </h5>
              <div className='content_line d-none d-sm-block'></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default VendorsSearchCategory
